<!-- HEADER -->
<div class="bg-image">
  <div
    class="header flex justify-content-between lg:flex-nowrap flex-wrap bg-white"
  >
    <div class="flex gap-3 align-content-end align-items-center">
      <img class="logo" src="./assets/icons/logo_top.png" alt="Λογότυπο ΕΟΠΥΥ" />
      <div class="mb-10">
        <h2>{{ appTitle }}</h2>
        <h4>{{ appSubtitle }}</h4>
      </div>
    </div>

    <img
      src="./assets/icons/ellada2.png"
      alt="Ellada Logo"
      class="w-11rem"
      style="align-self: center"
    />
    <!-- <img
      src="./assets/icons/logo_democracy.png"
      alt="Ellada Logo"
      class="w-16rem"
      style="align-self: center"
    /> -->
  </div>
  <hr class="shadow-1" />

  <!-- BODY -->
  <div class="flex justify-content-center min-height-50">
    <div class="flex flex-column mt-8 p-3 border-round surface-card shadow-1">
      <div
        *ngIf="isStageEnvironment"
        class="flex gap-2 justify-content-center align-items-center text-primary text-lg border-bottom-2 border-primary pb-3 font-semibold m-3"
      >
        <i class="pi pi-exclamation-triangle text-2xl"></i> ΔΟΚΙΜΑΣΤΙΚΟ
        ΠΕΡΙΒΑΛΛΟΝ
      </div>

      <div class="flex flex-column gap-2 align-items-center mx-4 mt-2">
        <div class="text-3xl mb-3 mx-5">Εισάγετε τα στοιχεία χρήστη</div>
        <eo-form
          [config]="authFormConfig"
          [submitButtonLoading]="isLoginLoading()"
          (formSubmit)="onSubmit()"
        />
        <a
          class="text-primary cursor-pointer align-self-end p-pt-2 mt-1"
          (click)="forgotPwdDialog.show()"
        >
          Ξέχασα τον κωδικό μου
        </a>
        <app-forgot-password-dialog
          #forgotPwdDialog
        ></app-forgot-password-dialog>
      </div>
    </div>
  </div>

  <!-- FOOTER -->
  <div
    class="flex justify-content-between align-items-end px-4 absolute bottom-0 left-0 w-full"
    [ngClass]="{
      sticky: isSticky
    }"
  >
    <p class="flex-1 text-left">
      Δ/νση Πληροφορικής ΕΟΠΥΥ © 2025. Version
      {{ appVersion }}
    </p>

    <p class="flex-1 text-right">{{ today }}</p>
  </div>
</div>
